import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router";
import SelectProduct from "../../../components/SelectProduct";
import dayjs from "dayjs";
import API from "../../../services/api-request";
import { useState } from "react";

const AddRequestInbound = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { schedule_at, products, note } = values;

      let dataForm = {};

      dataForm = {
        schedule_at: dayjs(schedule_at).format("YYYY-MM-DD"),
        products: products.map((e) => {
          return {
            ...e,
            estimate_qty:
              typeof e.estimate_qty === "undefined" ? 0 : e.estimate_qty,
          };
        }),
        note: note,
      };

      console.log(dataForm);

      await API.Post("transaction/inbound", dataForm);
      message.success("Inbound has been added");
      addForm.resetFields();
      handleCancel();
    } catch (err) {
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      <Form
        form={addForm}
        name="Add Form"
        style={{
          margin: "0 auto",
        }}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          products: [{}], // Memberikan default 1 item kosong
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[8, 8]}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label="Tanggal Masuk"
              name="schedule_at"
              rules={[
                {
                  required: true,
                  message: "Please input your tanggal masuk!",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                placeholder="Pilih Tanggal"
                disabledDate={(current) =>
                  current <= dayjs().subtract(1, "day")
                }
              />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}></Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item label="Silahkan Pilih Produk">
              <Form.List name="products">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Row key={field.key} gutter={16} align="middle">
                        {/* Jenis Produk */}
                        <Col span={6}>
                          <Form.Item
                            {...field}
                            name={[field.name, "product_id"]}
                            fieldKey={[field.fieldKey, "product_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis produk!",
                              },
                            ]}
                          >
                            <SelectProduct />
                          </Form.Item>
                        </Col>

                        {/* Estimasi Berat */}
                        <Col span={4}>
                          <Form.Item
                            {...field}
                            name={[field.name, "estimate_weight"]}
                            fieldKey={[field.fieldKey, "estimate_weight"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input estimasi berat!",
                              },
                              {
                                pattern: /^\d+$/,
                                message: "Please enter a valid number!",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Estimasi Berat"
                              suffix={"Kg"}
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              step={"0.1"}
                            />
                          </Form.Item>
                        </Col>

                        {/* Estimasi Jumlah Pack */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "estimate_qty"]}
                            fieldKey={[field.fieldKey, "estimate_qty"]}
                            rules={[
                              {
                                pattern: /^\d+$/,
                                message: "Please enter a valid number!",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Jumlah Pack"
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Spesifikasi */}
                        <Col span={7}>
                          <Form.Item
                            {...field}
                            name={[field.name, "estimate_specification"]}
                            fieldKey={[
                              field.fieldKey,
                              "estimate_specification",
                            ]}
                          >
                            <Input placeholder="Spesifikasi" />
                          </Form.Item>
                        </Col>

                        {/* Hapus */}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "romove"]}
                            fieldKey={[field.fieldKey, "romove"]}
                          >
                            {index > 0 && (
                              <MinusCircleOutlined
                                style={{
                                  fontSize: "20px",
                                  color: "red",
                                }}
                                onClick={() => remove(field.name)}
                              />
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    ))}
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      Tambah Jenis Produk
                    </Button>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
          {/* <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item label="Keterangan" name="note">
              <TextArea
                placeholder="Keterangan"
                autoSize={{
                  minRows: 2,
                  maxRows: 6,
                }}
              />
            </Form.Item>
          </Col> */}
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              style={{
                width: "100%",
                backgroundColor: "orange",
                borderColor: "orange",
                color: "white",
              }}
              type="primary"
              onClick={() => handleCancel()}
            >
              Kembali
            </Button>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              key="submit"
              htmlType="submit"
              style={buttonStyle}
              type="primary"
              loading={loading}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default AddRequestInbound;
